import { render, staticRenderFns } from "./HomeEcological.vue?vue&type=template&id=395e8a0b&scoped=true&"
import script from "./HomeEcological.vue?vue&type=script&lang=js&"
export * from "./HomeEcological.vue?vue&type=script&lang=js&"
import style0 from "./HomeEcological.vue?vue&type=style&index=0&id=395e8a0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e8a0b",
  null
  
)

export default component.exports